"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateRate = void 0;
const tslib_1 = require("tslib");
const default_rate_calculator_1 = require("./default-rate-calculator");
const lump_sum_rate_calculator_1 = require("./lump-sum-rate-calculator/lump-sum-rate-calculator");
const models_1 = require("./models");
function calculateRate(rate, options) {
    const threeYear = calculateFaceAndPremium(options, rate, rate.threeYearFace, rate.threeYearPremium);
    const fiveYear = calculateFaceAndPremium(options, rate, rate.fiveYearFace, rate.fiveYearPremium);
    const sevenYear = calculateFaceAndPremium(options, rate, rate.sevenYearFace, rate.sevenYearPremium);
    const tenYear = calculateFaceAndPremium(options, rate, rate.tenYearFace, rate.tenYearPremium);
    return Object.assign(Object.assign({}, rate), { threeYearFace: threeYear.faceAmount, threeYearPremium: threeYear.premium, fiveYearFace: fiveYear.faceAmount, fiveYearPremium: fiveYear.premium, sevenYearFace: sevenYear.faceAmount, sevenYearPremium: sevenYear.premium, tenYearFace: tenYear.faceAmount, tenYearPremium: tenYear.premium });
}
exports.calculateRate = calculateRate;
function calculateFaceAndPremium(options, rate, faceFactor, premiumFactor) {
    if (options.lumpSumAmount) {
        return calculateRateForLumpSum(options, rate, faceFactor, premiumFactor);
    }
    return default_rate_calculator_1.DefaultRateCalculator.calculate(options, rate, faceFactor, premiumFactor);
}
function calculateRateForLumpSum(_a, rate, faceFactor, premiumFactor) {
    var { lumpSumAmount } = _a, options = tslib_1.__rest(_a, ["lumpSumAmount"]);
    const { premium } = default_rate_calculator_1.DefaultRateCalculator.calculate(options, rate, faceFactor, premiumFactor);
    if (!premium) {
        return models_1.emptyFaceAndPremium();
    }
    if (lumpSumAmount && lumpSumAmount < premium) {
        return models_1.emptyFaceAndPremium();
    }
    return lump_sum_rate_calculator_1.LumpSumRateCalculator.calculate(Object.assign(Object.assign({}, options), { lumpSumAmount }), rate, faceFactor, premiumFactor);
}
//# sourceMappingURL=rate-calculator.js.map